import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgSelfEmployment(props: ISvgProps) {
	return (
		<svg width={60} height={61} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#SelfEmployment_svg__a)">
				<path
					d="M31.247 39.716h2.45a6.122 6.122 0 0 1 4.413-4.793 13.868 13.868 0 0 0-6.916-6.155 12.539 12.539 0 0 1-7.19 2.287c-2.667 0-5.173-.817-7.188-2.287-5.12 2.07-8.716 7.025-8.716 12.855v5.663a2.417 2.417 0 0 0 2.395 2.395h15.903c-.164-.38-.217-.817-.217-1.253v-3.595c0-2.83 2.29-5.117 5.066-5.117ZM24.002 27.895a9.507 9.507 0 0 0 9.531-9.53c0-5.283-4.301-9.476-9.53-9.476a9.508 9.508 0 0 0-9.532 9.53c0 5.283 4.249 9.476 9.531 9.476Z"
					fill={props.primaryColor}
				/>
				<path
					d="M42.792 54.855h-1.961a2.824 2.824 0 0 1-2.832-2.723c-2.668-.164-5.119-.328-7.408-.762v6.917c0 1.306 1.034 2.342 2.287 2.342h17.81a2.325 2.325 0 0 0 2.341-2.342l.003-6.862c-2.234.381-4.738.6-7.409.709-.053 1.523-1.25 2.72-2.831 2.72v.001ZM52.379 42.492H47.26v-1.689c0-1.798-1.47-3.323-3.323-3.323H39.69c-1.798 0-3.324 1.47-3.324 3.323v1.69h-5.119a2.266 2.266 0 0 0-2.287 2.286v3.596c0 .328.218.6.545.653 2.234.436 5.066.817 8.55.98a2.813 2.813 0 0 1 2.832-2.83h1.962a2.813 2.813 0 0 1 2.831 2.83c3.485-.163 6.32-.544 8.498-.98a.647.647 0 0 0 .544-.653v-3.596c0-1.25-1.035-2.287-2.342-2.287Zm-7.953-.217h-5.23v-1.47c0-.272.218-.49.49-.49l4.25-.001c.273 0 .49.217.49.49v1.471Z"
					fill={props.secondaryColor}
				/>
				<path
					d="M42.792 52.788a.744.744 0 0 0 .762-.762v-1.962a.744.744 0 0 0-.762-.761h-1.961a.744.744 0 0 0-.762.762v1.961c0 .436.328.762.762.762h1.961Z"
					fill={props.secondaryColor}
				/>
				<circle cx={48.294} cy={21.143} r={1.634} fill={props.secondaryColor} />
				<circle cx={4.723} cy={3.714} r={2.723} fill={props.secondaryColor} />
				<circle cx={3.362} cy={15.967} r={1.362} fill={props.secondaryColor} />
			</g>
			<defs>
				<clipPath id="SelfEmployment_svg__a">
					<path fill="#fff" transform="translate(0 .99)" d="M0 0h60v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgSelfEmployment;
